export const getMetadata = function (x) {
  const metadata = process.env.VUE_APP_SITE_NAMESPACE + '/user_metadata'
  if (this.$auth.user?.[metadata]) {
    return this.$auth.user[metadata][x]
  }
}
